import { Box, Button, Typography } from "@mui/material";

interface IScheduleCursorFooterProps {
    count: number;
    total: number;
    statusLabel: string;
    typeLabel: string;
    onPrevious?: () => void;
    onNext?: () => void;
    hasPrevious?: boolean;
    hasNext?: boolean;
}

/**
 * Replaces the DataGrid's built-in numbered footer. `total` is scoped to the current
 * status+type partition - the API's `total` is per-partition, never a collection-wide total.
 */
const ScheduleCursorFooter = ({
    count,
    total,
    statusLabel,
    typeLabel,
    onPrevious,
    onNext,
    hasPrevious = false,
    hasNext = false,
}: IScheduleCursorFooterProps): JSX.Element => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 16px",
            borderTop: "1px solid rgba(224, 224, 224, 1)",
        }}
    >
        <Typography variant="body2" color="text.secondary">
            {`Showing ${count} of ${total} schedules · ${statusLabel} · ${typeLabel}`}
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
            <Button size="small" variant="outlined" disabled={!hasPrevious} onClick={onPrevious}>
                Previous
            </Button>
            <Button size="small" variant="outlined" disabled={!hasNext} onClick={onNext}>
                Next
            </Button>
        </Box>
    </Box>
);

export default ScheduleCursorFooter;
